export default __webpack_public_path__ + "static/media/hero_3.c3950703.png";